export default "__VITE_ASSET__C2VoY6k$__"